<template>
    <div>
      <div class="header header-default">
        <div class="container d-flex">
          <div class="header-logo">
            <a href="/beta" class="logo-link header-nav-link "> <img src="/beta/static/logo.svg" style="width: 45px;margin-right: 5px" /><b class="text-womia">Womia Box </b></a>
          </div>
          <div class="header-nav">
            <ul class="nav pull-right">
              <li>
                  <a href="#" class=" nav-item nav-link dropdown-toggle mr-md-2" id="bd-versions" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <img  src="/beta/static/default-user-128.png" class="user-img" width="128"
                      height="128" alt="" />
                    <span class="hidden-md hidden-sm hidden-xs">Admin</span>
                    <b class="caret"></b>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="bd-versions">
                    <a href="javascript:;" class="dropdown-item" >Settings</a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="/beta/admin/logout">Log out</a>
                  </div>
              </li>
            </ul>
          </div>
          <button class="header-mobile-nav-toggler" type="button" data-toggle="header-mobile-nav">
            <span class="header-mobile-nav-toggler-icon"></span>
          </button>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vuex from "vuex";
  
  export default {
    name: "navbar"
  };
  </script>
  
  <style scoped>
  .header .navbar-nav > li > .dropdown-menu {
    margin-top: 0;
    border-top: 1px solid #f2f3f4;
    box-shadow: 0 13px 25px -2px rgba(0, 0, 0, 0.2);
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  
  .header .dropdown-menu {
    padding: 10px;
    min-width: 100px;
  }
  
  .dropdown-item,
  .dropdown-menu > li > a {
    display: block;
    padding: 5px 15px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    text-decoration: none;
  }
  
  .dropdown-divider,
  .dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }
  
  .header-nav .nav > li.open > a,
  .header-nav .nav > li.open > a:focus,
  .header-nav .nav > li.open > a:hover,
  .header-nav .nav > li > a:focus,
  .header-nav .nav > li > a:hover {
    background: none;
    color: #707478;
  }
  
  .header-nav .nav > li > a {
    color: #212121;
    line-height: 56px;
  }
  
  .caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 2px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-top: 4px solid\9;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
  }
  
  .header .dropdown-menu {
    padding: 10px;
    min-width: 100px;
  }
  
  .dropdown-item,
  .dropdown-menu > li > a {
    display: block;
    padding: 5px 15px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    text-decoration: none;
  }
  
  .dropdown-divider,
  .dropdown-menu .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
  }
  
  .header-nav .nav > li {
    float: left;
  }
  
  .nav > li,
  .nav > li > a {
    position: relative;
    display: block;
  }
  
  .open > .dropdown-menu {
    display: block;
  }
  .header .user-img {
    float: left;
    width: 36px;
    height: 36px;
    border-radius: 40px;
    margin: 10px 10px 10px 0;
}
@media (min-width: 1200px){
.container, .container-lg, .container-md, .container-sm, .container-xl {
    max-width: 98%;
}}
  </style>
  


// WEBPACK FOOTER //
// src/admin/components/Navbar.vue